import { api } from './api';
import type { Notification, ApiResponse } from '@soundbyte/types';

/**
 * Notification Service
 *
 * Handles user notifications via the backend API.
 */
class NotificationService {
  /**
   * Get all notifications for current user
   */
  async getAll(): Promise<ApiResponse<Notification[]>> {
    return api.get<Notification[]>('/notifications');
  }

  /**
   * Get unread notifications count
   */
  async getUnreadCount(): Promise<ApiResponse<{ count: number }>> {
    return api.get<{ count: number }>('/notifications/unread-count');
  }

  /**
   * Mark notification as read
   */
  async markAsRead(id: string): Promise<ApiResponse<{ message: string }>> {
    return api.patch<{ message: string }>(`/notifications/${id}/read`);
  }

  /**
   * Mark all notifications as read
   */
  async markAllAsRead(): Promise<ApiResponse<{ message: string }>> {
    return api.post<{ message: string }>('/notifications/mark-all-read');
  }

  /**
   * Delete a notification
   */
  async delete(id: string): Promise<ApiResponse<{ message: string }>> {
    return api.delete<{ message: string }>(`/notifications/${id}`);
  }

  /**
   * Clear all notifications
   */
  async clearAll(): Promise<ApiResponse<{ message: string }>> {
    return api.delete<{ message: string }>('/notifications');
  }
}

export const notificationService = new NotificationService();
